import default_user from '../images/user.png';
import default_picture from '../images/default_img.png';
import default_cover from '../images/banner-default.jpg';
import picture_loading from '../images/Loading_icon.gif';

const API_URL = process.env.REACT_APP_API_URL;

export const cutText = (text = "", maxLenght = 0) => {
    let text_formated = String(text).trim();

    if (text_formated.length > maxLenght) text_formated = (text_formated.substring(0, maxLenght)) + "...";

    return text_formated;
}

export function fechaToText(fechaStr = null) {
    if (!fechaStr) return "No se detecto una fecha";
    const fecha = new Date(fechaStr);

    // formato dia + mes (en texto)
    const opciones = {
        day: '2-digit',
        month: 'long'
    };

    //formatear la fecha
    const fechaFormateada = new Intl.DateTimeFormat('es-ES', opciones).format(fecha);

    // retornar texto:
    return fechaFormateada.replace(/(.*) (.*)/, '$1 de $2');
}

export function sum(a, b) {
    return a + b;
}

export const URl_Server = () => {
    return API_URL;
}

export const returnFullURL = (url, type = "profile") => {
    if (type == "wait") return picture_loading;
    if (!url && type == "profile") return default_user;
    if (!url && type == "picture") return default_picture;
    if (!url && type == "cover") return default_cover;


    return API_URL + url;
    // return url;
}

export const convertString = (value) => {
    return String(value);
}

export function numeroAleatorio(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

export const returnCurrentDate = (especial = false) => {
    const fecha = new Date();
    const day = fecha.getDate();
    const month = fecha.getMonth() + 1;
    const year = fecha.getFullYear();

    let result;
    if (!especial) result = `${year}-${month < 10 ? ('0' + month) : month}-${day < 10 ? ('0' + day) : day}`;
    else result = `${day < 10 ? ('0' + day) : day}-${month < 10 ? ('0' + month) : month}-${year}`;

    return result;
}

export const returnCurrentDateTime = () => {
    const fecha = new Date();
    const day = fecha.getDate();
    const month = fecha.getMonth() + 1;
    const year = fecha.getFullYear();

    const hour = fecha.getHours();
    const minute = fecha.getMinutes();
    const seconds = fecha.getSeconds();

    const result = `${year}-${month < 10 ? ('0' + month) : month}-${day < 10 ? ('0' + day) : day}T${hour < 10 ? ('0' + hour) : hour}:${minute < 10 ? ('0' + minute) : minute}:${seconds < 10 ? ('0' + seconds) : seconds}`;
    return result;
}

export const returnOldData = (oldResultsSearch = {}) => {
    let new_obj = [];

    Object.keys(oldResultsSearch).forEach(grupo => {
        oldResultsSearch[grupo].forEach((obj, index) => {
            new_obj.push(obj);
        });
    });

    let filtered_data = [];

    new_obj.forEach((obj_function, index) => {
        for (let i = 0; i < filtered_data.length; i++) {
            if (filtered_data[i]?.perfil == obj_function?.perfil && filtered_data[i]?.fullName == obj_function?.fullName) break;

            if (filtered_data.length == (i + 1)) filtered_data.push(obj_function);
        }
        // obj_function.type
        if (index == 0) filtered_data.push(obj_function);
    });

    return filtered_data;
}

export const getCodeColor = (color = '#000') => {
    const value = String(color);
    if (value.length <= 3) return "#79716B";

    const value_sub = value.substring(0, 3);
    if (value_sub != 'var') return value;

    const getVar = value.substring(4, value.length - 1);
    const getCode = getComputedStyle(document.documentElement).getPropertyValue(getVar).trim();

    return getCode;
}

export const countries = [
    { nameCode: "af", dialCode: "93", name: "+93", fullname: "Afghanistan" },
    { nameCode: "al", dialCode: "355", name: "+355", fullname: "Albania" },
    { nameCode: "de", dialCode: "49", name: "+49", fullname: "Germany" },
    { nameCode: "ad", dialCode: "376", name: "+376", fullname: "Andorra" },
    { nameCode: "ao", dialCode: "244", name: "+244", fullname: "Angola" },
    { nameCode: "ag", dialCode: "1", name: "+1", fullname: "Antigua and Barbuda" },
    { nameCode: "sa", dialCode: "966", name: "+966", fullname: "Saudi Arabia" },
    { nameCode: "dz", dialCode: "213", name: "+213", fullname: "Algeria" },
    { nameCode: "ar", dialCode: "54", name: "+54", fullname: "Argentina" },
    { nameCode: "am", dialCode: "374", name: "+374", fullname: "Armenia" },
    { nameCode: "au", dialCode: "61", name: "+61", fullname: "Australia" },
    { nameCode: "at", dialCode: "43", name: "+43", fullname: "Austria" },
    { nameCode: "az", dialCode: "994", name: "+994", fullname: "Azerbaijan" },
    { nameCode: "bs", dialCode: "1", name: "+1", fullname: "Bahamas" },
    { nameCode: "bd", dialCode: "880", name: "+880", fullname: "Bangladesh" },
    { nameCode: "bb", dialCode: "1", name: "+1", fullname: "Barbados" },
    { nameCode: "bh", dialCode: "973", name: "+973", fullname: "Bahrain" },
    { nameCode: "be", dialCode: "32", name: "+32", fullname: "Belgium" },
    { nameCode: "bz", dialCode: "501", name: "+501", fullname: "Belize" },
    { nameCode: "bj", dialCode: "229", name: "+229", fullname: "Benin" },
    { nameCode: "by", dialCode: "375", name: "+375", fullname: "Belarus" },
    { nameCode: "mm", dialCode: "95", name: "+95", fullname: "Myanmar" },
    { nameCode: "bo", dialCode: "591", name: "+591", fullname: "Bolivia" },
    { nameCode: "ba", dialCode: "387", name: "+387", fullname: "Bosnia and Herzegovina" },
    { nameCode: "bw", dialCode: "267", name: "+267", fullname: "Botswana" },
    { nameCode: "br", dialCode: "55", name: "+55", fullname: "Brazil" },
    { nameCode: "bn", dialCode: "673", name: "+673", fullname: "Brunei Darussalam" },
    { nameCode: "bg", dialCode: "359", name: "+359", fullname: "Bulgaria" },
    { nameCode: "bf", dialCode: "226", name: "+226", fullname: "Burkina Faso" },
    { nameCode: "bi", dialCode: "257", name: "+257", fullname: "Burundi" },
    { nameCode: "bt", dialCode: "975", name: "+975", fullname: "Bhutan" },
    { nameCode: "cv", dialCode: "238", name: "+238", fullname: "Cape Verde" },
    { nameCode: "kh", dialCode: "855", name: "+855", fullname: "Cambodia" },
    { nameCode: "cm", dialCode: "237", name: "+237", fullname: "Cameroon" },
    { nameCode: "ca", dialCode: "1", name: "+1", fullname: "Canada" },
    { nameCode: "qa", dialCode: "974", name: "+974", fullname: "Qatar" },
    { nameCode: "td", dialCode: "235", name: "+235", fullname: "Chad" },
    { nameCode: "cl", dialCode: "56", name: "+56", fullname: "Chile" },
    { nameCode: "cn", dialCode: "86", name: "+86", fullname: "China" },
    { nameCode: "cy", dialCode: "357", name: "+357", fullname: "Cyprus" },
    { nameCode: "va", dialCode: "39", name: "+39", fullname: "Vatican City State" },
    { nameCode: "co", dialCode: "57", name: "+57", fullname: "Colombia" },
    { nameCode: "km", dialCode: "269", name: "+269", fullname: "Union of the Comoros" },
    { nameCode: "kp", dialCode: "850", name: "+850", fullname: "Korea" },
    { nameCode: "kr", dialCode: "82", name: "+82", fullname: "Korea" },
    { nameCode: "ci", dialCode: "225", name: "+225", fullname: "Côte d'Ivoire" },
    { nameCode: "cr", dialCode: "506", name: "+506", fullname: "Costa Rica" },
    { nameCode: "hr", dialCode: "385", name: "+385", fullname: "Croatia" },
    { nameCode: "cu", dialCode: "53", name: "+53", fullname: "Cuba" },
    { nameCode: "dk", dialCode: "45", name: "+45", fullname: "Kingdom of Denmark" },
    { nameCode: "dm", dialCode: "1", name: "+1", fullname: "Commonwealth of Dominica" },
    { nameCode: "ec", dialCode: "593", name: "+593", fullname: "Ecuador" },
    { nameCode: "eg", dialCode: "20", name: "+20", fullname: "Arab Egypt" },
    { nameCode: "sv", dialCode: "503", name: "+503", fullname: "El Salvador" },
    { nameCode: "ae", dialCode: "971", name: "+971", fullname: "United Arab Emirates" },
    { nameCode: "er", dialCode: "291", name: "+291", fullname: "State of Eritrea" },
    { nameCode: "sk", dialCode: "421", name: "+421", fullname: "Slovakia" },
    { nameCode: "si", dialCode: "386", name: "+386", fullname: "Slovenia" },
    { nameCode: "es", dialCode: "34", name: "+34", fullname: "Kingdom of Spain" },
    { nameCode: "us", dialCode: "1", name: "+1", fullname: "United States of America" },
    { nameCode: "ee", dialCode: "372", name: "+372", fullname: "Estonia" },
    { nameCode: "et", dialCode: "251", name: "+251", fullname: "Federal Democratic Ethiopia" },
    { nameCode: "ph", dialCode: "63", name: "+63", fullname: "Philippines" },
    { nameCode: "fi", dialCode: "358", name: "+358", fullname: "Finland" },
    { nameCode: "fj", dialCode: "679", name: "+679", fullname: "Fiji" },
    { nameCode: "fr", dialCode: "33", name: "+33", fullname: "French Republic" },
    { nameCode: "ga", dialCode: "241", name: "+241", fullname: "Gabonese Republic" },
    { nameCode: "gm", dialCode: "220", name: "+220", fullname: "Gambia" },
    { nameCode: "ge", dialCode: "995", name: "+995", fullname: "Georgia" },
    { nameCode: "gh", dialCode: "233", name: "+233", fullname: "Ghana" },
    { nameCode: "gd", dialCode: "1", name: "+1", fullname: "Grenada" },
    { nameCode: "gr", dialCode: "30", name: "+30", fullname: "Hellenic Republic" },
    { nameCode: "gt", dialCode: "502", name: "+502", fullname: "Guatemala" },
    { nameCode: "gy", dialCode: "592", name: "+592", fullname: "Co-operative Guyana" },
    { nameCode: "gn", dialCode: "224", name: "+224", fullname: "Guinea" },
    { nameCode: "gq", dialCode: "240", name: "+240", fullname: "Equatorial Guinea" },
    { nameCode: "gw", dialCode: "245", name: "+245", fullname: "Guinea-Bissau" },
    { nameCode: "ht", dialCode: "509", name: "+509", fullname: "Haiti" },
    { nameCode: "hn", dialCode: "504", name: "+504", fullname: "Honduras" },
    { nameCode: "hu", dialCode: "36", name: "+36", fullname: "Hungary" },
    { nameCode: "in", dialCode: "91", name: "+91", fullname: "India" },
    { nameCode: "id", dialCode: "62", name: "+62", fullname: "Indonesia" },
    { nameCode: "iq", dialCode: "964", name: "+964", fullname: "Iraq" },
    { nameCode: "ir", dialCode: "98", name: "+98", fullname: "Islamic Iran" },
    { nameCode: "ie", dialCode: "353", name: "+353", fullname: "Ireland" },
    { nameCode: "is", dialCode: "354", name: "+354", fullname: "Iceland" },
    { nameCode: "mh", dialCode: "692", name: "+692", fullname: "Marshall Islands" },
    { nameCode: "sb", dialCode: "677", name: "+677", fullname: "Solomon Islands" },
    { nameCode: "il", dialCode: "972", name: "+972", fullname: "State of Israel" },
    { nameCode: "it", dialCode: "39", name: "+39", fullname: "Italian Republic" },
    { nameCode: "jm", dialCode: "1", name: "+1", fullname: "Jamaica" },
    { nameCode: "jp", dialCode: "81", name: "+81", fullname: "Japan" },
    { nameCode: "jo", dialCode: "962", name: "+962", fullname: "Hashemite Kingdom of Jordan" },
    { nameCode: "kz", dialCode: "7", name: "+7", fullname: "Kazakhstan" },
    { nameCode: "ke", dialCode: "254", name: "+254", fullname: "Kenya" },
    { nameCode: "kg", dialCode: "996", name: "+996", fullname: "Kyrgyz Republic" },
    { nameCode: "ki", dialCode: "686", name: "+686", fullname: "Kiribati" },
    { nameCode: "kw", dialCode: "965", name: "+965", fullname: "State of Kuwait" },
    { nameCode: "la", dialCode: "856", name: "+856", fullname: "Lao People's Democratic Republic" },
    { nameCode: "ls", dialCode: "266", name: "+266", fullname: "Kingdom of Lesotho" },
    { nameCode: "lv", dialCode: "371", name: "+371", fullname: "Latvia" },
    { nameCode: "lb", dialCode: "961", name: "+961", fullname: "Lebanese Republic" },
    { nameCode: "lr", dialCode: "231", name: "+231", fullname: "Liberia" },
    { nameCode: "ly", dialCode: "218", name: "+218", fullname: "State of Libya" },
    { nameCode: "li", dialCode: "423", name: "+423", fullname: "Principality of Liechtenstein" },
    { nameCode: "lt", dialCode: "370", name: "+370", fullname: "Lithuania" },
    { nameCode: "lu", dialCode: "352", name: "+352", fullname: "Grand Duchy of Luxembourg" },
    { nameCode: "mk", dialCode: "389", name: "+389", fullname: "North Macedonia" },
    { nameCode: "mg", dialCode: "261", name: "+261", fullname: "Madagascar" },
    { nameCode: "my", dialCode: "60", name: "+60", fullname: "Malaysia" },
    { nameCode: "mw", dialCode: "265", name: "+265", fullname: "Malawi" },
    { nameCode: "mv", dialCode: "960", name: "+960", fullname: "Maldives" },
    { nameCode: "ml", dialCode: "223", name: "+223", fullname: "Mali" },
    { nameCode: "mt", dialCode: "356", name: "+356", fullname: "Malta" },
    { nameCode: "ma", dialCode: "212", name: "+212", fullname: "Kingdom of Morocco" },
    { nameCode: "mu", dialCode: "230", name: "+230", fullname: "Mauritius" },
    { nameCode: "mr", dialCode: "222", name: "+222", fullname: "Islamic Mauritania" },
    { nameCode: "mx", dialCode: "52", name: "+52", fullname: "United Mexican States" },
    { nameCode: "fm", dialCode: "691", name: "+691", fullname: "Federated States of Micronesia" },
    { nameCode: "md", dialCode: "373", name: "+373", fullname: "Moldova" },
    { nameCode: "mc", dialCode: "377", name: "+377", fullname: "Principality of Monaco" },
    { nameCode: "mn", dialCode: "976", name: "+976", fullname: "Mongolia" },
    { nameCode: "me", dialCode: "382", name: "+382", fullname: "Montenegro" },
    { nameCode: "mz", dialCode: "258", name: "+258", fullname: "Mozambique" },
    { nameCode: "na", dialCode: "264", name: "+264", fullname: "Namibia" },
    { nameCode: "nr", dialCode: "674", name: "+674", fullname: "Nauru" },
    { nameCode: "np", dialCode: "977", name: "+977", fullname: "Federal Democratic Nepal" },
    { nameCode: "ni", dialCode: "505", name: "+505", fullname: "Nicaragua" },
    { nameCode: "ne", dialCode: "227", name: "+227", fullname: "Nigueria" },
    { nameCode: "ng", dialCode: "234", name: "+234", fullname: "Federal Nigeria" },
    { nameCode: "no", dialCode: "47", name: "+47", fullname: "Kingdom of Norway" },
    { nameCode: "nz", dialCode: "64", name: "+64", fullname: "New Zealand" },
    { nameCode: "om", dialCode: "968", name: "+968", fullname: "Sultanate of Oman" },
    { nameCode: "nl", dialCode: "31", name: "+31", fullname: "Kingdom of the Netherlands" },
    { nameCode: "pk", dialCode: "92", name: "+92", fullname: "Islamic Pakistan" },
    { nameCode: "pw", dialCode: "680", name: "+680", fullname: "Palau" },
    { nameCode: "pa", dialCode: "507", name: "+507", fullname: "Panama" },
    { nameCode: "pg", dialCode: "675", name: "+675", fullname: "Papua New Guinea" },
    { nameCode: "py", dialCode: "595", name: "+595", fullname: "Paraguay" },
    { nameCode: "pe", dialCode: "51", name: "+51", fullname: "Peru" },
    { nameCode: "pl", dialCode: "48", name: "+48", fullname: "Poland" },
    { nameCode: "pt", dialCode: "351", name: "+351", fullname: "Portuguese Republic" },
    { nameCode: "gb", dialCode: "44", name: "+44", fullname: "United Kingdom of Great Britain and Northern Ireland" },
    { nameCode: "cf", dialCode: "236", name: "+236", fullname: "Central African Republic" },
    { nameCode: "cz", dialCode: "420", name: "+420", fullname: "Czech Republic" },
    { nameCode: "cg", dialCode: "242", name: "+242", fullname: "the Congo" },
    { nameCode: "cd", dialCode: "243", name: "+243", fullname: "Democratic the Congo" },
    { nameCode: "do", dialCode: "1", name: "+1", fullname: "Dominican Republic" },
    { nameCode: "za", dialCode: "27", name: "+27", fullname: "South Africa" },
    { nameCode: "rw", dialCode: "250", name: "+250", fullname: "Rwanda" },
    { nameCode: "ro", dialCode: "40", name: "+40", fullname: "Romania" },
    { nameCode: "ru", dialCode: "7", name: "+7", fullname: "Russian Federation" },
    { nameCode: "ws", dialCode: "685", name: "+685", fullname: "Independent State of Samoa" },
    { nameCode: "kn", dialCode: "1", name: "+1", fullname: "Federation of Saint Kitts and Nevis" },
    { nameCode: "sm", dialCode: "378", name: "+378", fullname: "San Marino" },
    { nameCode: "vc", dialCode: "1", name: "+1", fullname: "Saint Vincent and the Grenadines" },
    { nameCode: "lc", dialCode: "1", name: "+1", fullname: "Saint Lucia" },
    { nameCode: "st", dialCode: "239", name: "+239", fullname: "Democratic São Tomé and Príncipe" },
    { nameCode: "sn", dialCode: "221", name: "+221", fullname: "Senegal" },
    { nameCode: "rs", dialCode: "381", name: "+381", fullname: "Serbia" },
    { nameCode: "sc", dialCode: "248", name: "+248", fullname: "Seychelles" },
    { nameCode: "sl", dialCode: "232", name: "+232", fullname: "Sierra Leone" },
    { nameCode: "sg", dialCode: "65", name: "+65", fullname: "Singapore" },
    { nameCode: "sy", dialCode: "963", name: "+963", fullname: "Syrian Arab Republic" },
    { nameCode: "so", dialCode: "252", name: "+252", fullname: "Federal Somalia" },
    { nameCode: "lk", dialCode: "94", name: "+94", fullname: "Democratic Socialist Sri Lanka" },
    { nameCode: "sz", dialCode: "268", name: "+268", fullname: "Kingdom of Eswatini" },
    { nameCode: "sd", dialCode: "249", name: "+249", fullname: "the Sudan" },
    { nameCode: "ss", dialCode: "211", name: "+211", fullname: "South Sudan" },
    { nameCode: "se", dialCode: "46", name: "+46", fullname: "Kingdom of Sweden" },
    { nameCode: "ch", dialCode: "41", name: "+41", fullname: "Swiss Confederation" },
    { nameCode: "sr", dialCode: "597", name: "+597", fullname: "Suriname" },
    { nameCode: "th", dialCode: "66", name: "+66", fullname: "Kingdom of Thailand" },
    { nameCode: "tz", dialCode: "255", name: "+255", fullname: "United Tanzania" },
    { nameCode: "tj", dialCode: "992", name: "+992", fullname: "Tajikistan" },
    { nameCode: "tl", dialCode: "670", name: "+670", fullname: "Democratic Timor‑Leste" },
    { nameCode: "tg", dialCode: "228", name: "+228", fullname: "Togolese Republic" },
    { nameCode: "to", dialCode: "676", name: "+676", fullname: "Kingdom of Tonga" },
    { nameCode: "tt", dialCode: "1", name: "+1", fullname: "Trinidad and Tobago" },
    { nameCode: "tn", dialCode: "216", name: "+216", fullname: "Tunisian Republic" },
    { nameCode: "tm", dialCode: "993", name: "+993", fullname: "Turkmenistan" },
    { nameCode: "tr", dialCode: "90", name: "+90", fullname: "Türkiye" },
    { nameCode: "tv", dialCode: "688", name: "+688", fullname: "Tuvalu" },
    { nameCode: "ua", dialCode: "380", name: "+380", fullname: "Ukraine" },
    { nameCode: "ug", dialCode: "256", name: "+256", fullname: "Uganda" },
    { nameCode: "uy", dialCode: "598", name: "+598", fullname: "Oriental Uruguay" },
    { nameCode: "uz", dialCode: "998", name: "+998", fullname: "Uzbekistan" },
    { nameCode: "vu", dialCode: "678", name: "+678", fullname: "Vanuatu" },
    { nameCode: "ve", dialCode: "58", name: "+58", fullname: "Bolivarian Venezuela" },
    { nameCode: "vn", dialCode: "84", name: "+84", fullname: "Socialist VietNam" },
    { nameCode: "ye", dialCode: "967", name: "+967", fullname: "Yemen" },
    { nameCode: "dj", dialCode: "253", name: "+253", fullname: "Djibouti" },
    { nameCode: "zm", dialCode: "260", name: "+260", fullname: "Zambia" },
    { nameCode: "zw", dialCode: "263", name: "+263", fullname: "Zimbabwe" }
];

export const diferenciaFechas = (fecha) => {
    const parse = (f) => {
        const [d, m, y] = f.split("-").map(Number);
        return new Date(y, m - 1, d);
    };

    let d1 = parse(fecha);
    let d2 = parse(returnCurrentDate(true));

    if (d1 > d2) [d1, d2] = [d2, d1];

    let años = d2.getFullYear() - d1.getFullYear();
    let meses = d2.getMonth() - d1.getMonth();
    let dias = d2.getDate() - d1.getDate();

    if (dias < 0) {
        meses--;
        const ultimoMes = new Date(d2.getFullYear(), d2.getMonth(), 0).getDate();
        dias += ultimoMes;
    }

    if (meses < 0) {
        años--;
        meses += 12;
    }

    let partes = [];

    if (años > 0) partes.push(`${años} ${años === 1 ? "año" : "años"}`);
    if (meses > 0) partes.push(`${meses} ${meses === 1 ? "mes" : "meses"}`);
    if (dias > 0) partes.push(`${dias} ${dias === 1 ? "día" : "días"}`);

    if (partes.length === 0) return "0 días";

    if (partes.length === 1) return partes[0];
    if (partes.length === 2) return `${partes[0]} con ${partes[1]}`;

    return `${partes[0]} con ${partes[1]} y ${partes[2]}`;
}

export const countriesCurrency = () => [
    { code: "BOB", currency: "Boliviano", country: "Bolivia" },
    { code: "USD", currency: "Dólar estadounidense", country: "Estados Unidos" },
    { code: "EUR", currency: "Euro", country: "Unión Europea" },
    { code: "GBP", currency: "Libra esterlina", country: "Reino Unido" },
    { code: "INR", currency: "Rupia india", country: "India" },
    { code: "CAD", currency: "Dólar canadiense", country: "Canadá" },
    { code: "AUD", currency: "Dólar australiano", country: "Australia" },
    { code: "CHF", currency: "Franco suizo", country: "Suiza" },
    { code: "MXN", currency: "Peso mexicano", country: "México" },
    { code: "AED", currency: "Dírham de los EAU", country: "Emiratos Árabes Unidos" },
    { code: "ALL", currency: "Lek albanés", country: "Albania" },
    { code: "AMD", currency: "Dram armenio", country: "Armenia" },
    { code: "ANG", currency: "Florín de las Antillas Neerlandesas", country: "Antillas Neerlandesas" },
    { code: "AOA", currency: "Kwanza angoleño", country: "Angola" },
    { code: "ARS", currency: "Peso argentino", country: "Argentina" },
    { code: "AWG", currency: "Florín arubeño", country: "Aruba" },
    { code: "AZN", currency: "Manat azerbaiyano", country: "Azerbaiyán" },
    { code: "BAM", currency: "Marco convertible", country: "Bosnia y Herzegovina" },
    { code: "BBD", currency: "Dólar de Barbados", country: "Barbados" },
    { code: "BDT", currency: "Taka bangladesí", country: "Bangladés" },
    { code: "BGN", currency: "Lev búlgaro", country: "Bulgaria" },
    { code: "BHD", currency: "Dinar bahreiní", country: "Baréin" },
    { code: "BMD", currency: "Dólar bermudeño", country: "Islas Bermudas" },
    { code: "BND", currency: "Dólar de Brunéi", country: "Brunéi" },
    { code: "BRL", currency: "Real brasileño", country: "Brasil" },
    { code: "BSD", currency: "Dólar bahameño", country: "Bahamas" },
    { code: "BTN", currency: "Ngultrum butanés", country: "Bután" },
    { code: "BWP", currency: "Pula botsuano", country: "Botsuana" },
    { code: "BZD", currency: "Dólar beliceño", country: "Belice" },
    { code: "CLP", currency: "Peso chileno", country: "Chile" },
    { code: "CNY", currency: "Yuan chino", country: "China" },
    { code: "COP", currency: "Peso colombiano", country: "Colombia" },
    { code: "CRC", currency: "Colón costarricense", country: "Costa Rica" },
    { code: "CVE", currency: "Escudo caboverdiano", country: "Cabo Verde" },
    { code: "CZK", currency: "Corona checa", country: "Chequia" },
    { code: "DJF", currency: "Franco yibutiano", country: "Yibuti" },
    { code: "DKK", currency: "Corona danesa", country: "Dinamarca" },
    { code: "DOP", currency: "Peso dominicano", country: "República Dominicana" },
    { code: "DZD", currency: "Dinar argelino", country: "Argelia" },
    { code: "EGP", currency: "Libra egipcia", country: "Egipto" },
    { code: "ETB", currency: "Birr etíope", country: "Etiopía" },
    { code: "FJD", currency: "Dólar fiyiano", country: "Fiyi" },
    { code: "FKP", currency: "Libra malvinense", country: "Islas Malvinas" },
    { code: "GEL", currency: "Lari georgiano", country: "Georgia" },
    { code: "GGP", currency: "Libra de Guernsey", country: "Guernsey" },
    { code: "GHS", currency: "Cedi ghanés", country: "Ghana" },
    { code: "GIP", currency: "Libra gibraltareña", country: "Gibraltar" },
    { code: "GMD", currency: "Dalasi gambiano", country: "Gambia" },
    { code: "GNF", currency: "Franco guineano", country: "Guinea" },
    { code: "GTQ", country: "Guatemala", currency: "Quetzal guatemalteco" },
    { code: "GYD", country: "Guyana", currency: "Dólar guyanés" },
    { code: "HKD", country: "Hong Kong", currency: "Dólar de Hong Kong" },
    { code: "HNL", country: "Honduras", currency: "Lempira hondureña" },
    { code: "HRK", country: "Croacia", currency: "Kuna croata" },
    { code: "HTG", country: "Haití", currency: "Gourde haitiana" },
    { code: "HUF", country: "Hungría", currency: "Florín húngaro" },
    { code: "IDR", country: "Indonesia", currency: "Rupia indonesia" },
    { code: "ILS", country: "Israel", currency: "Nuevo séquel" },
    { code: "IMP", country: "Isla de Man", currency: "Libra de Man" },
    { code: "ISK", country: "Islandia", currency: "Corona islandesa" },
    { code: "JEP", country: "Jersey", currency: "Libra de Jersey" },
    { code: "JMD", country: "Jamaica", currency: "Dólar jamaicano" },
    { code: "JOD", country: "Jordania", currency: "Dinar jordano" },
    { code: "JPY", country: "Japón", currency: "Yen japonés" },
    { code: "KES", country: "Kenia", currency: "Chelín keniata" },
    { code: "KGS", country: "Kirguistán", currency: "Som kirguís" },
    { code: "KHR", country: "Camboya", currency: "Riel camboyano" },
    { code: "KMF", country: "Comoras", currency: "Franco comorense" },
    { code: "KRW", country: "Corea del Sur", currency: "Won surcoreano" },
    { code: "KWD", country: "Kuwait", currency: "Dinar kuwaití" },
    { code: "KYD", country: "Islas Caimán", currency: "Dólar caimano" },
    { code: "KZT", country: "Kazajistán", currency: "Tenge kazajo" },
    { code: "LAK", country: "Laos", currency: "Kip laosiano" },
    { code: "LBP", country: "Líbano", currency: "Libra libanesa" },
    { code: "LKR", country: "Sri Lanka", currency: "Rupia ceilandesa" },
    { code: "LRD", country: "Liberia", currency: "Dólar liberiano" },
    { code: "LSL", country: "Lesoto", currency: "Loti de Lesoto" },
    { code: "MAD", country: "Marruecos", currency: "Dirham marroquí" },
    { code: "MDL", country: "Moldavia", currency: "Leu moldavo" },
    { code: "MGA", country: "Madagascar", currency: "Ariary malgache" },
    { code: "MKD", country: "Macedonia del Norte", currency: "Denar macedonio" },
    { code: "MNT", country: "Mongolia", currency: "Tugrik mongol" },
    { code: "MOP", country: "Macao", currency: "Pataca de Macao" },
    { code: "MRU", country: "Mauritania", currency: "Ouguiya mauritana" },
    { code: "MUR", country: "Mauricio", currency: "Rupia mauriciana" },
    { code: "MVR", country: "Maldivas", currency: "Rufiyaa de Maldivas" },
    { code: "MWK", country: "Malaui", currency: "Kwacha malauí" },
    { code: "MYR", country: "Malasia", currency: "Ringgit malayo" },
    { code: "MZN", country: "Mozambique", currency: "Metical mozambiqueño" },
    { code: "NAD", country: "Namibia", currency: "Dólar namibio" },
    { code: "NGN", country: "Nigeria", currency: "Naira nigeriana" },
    { code: "NIO", country: "Nicaragua", currency: "Córdoba nicaragüense" },
    { code: "NOK", country: "Noruega", currency: "Corona noruega" },
    { code: "NPR", country: "Nepal", currency: "Rupia nepalesa" },
    { code: "NZD", country: "Nueva Zelanda", currency: "Dólar neozelandés" },
    { code: "OMR", country: "Omán", currency: "Rial omaní" },
    { code: "PAB", country: "Panamá", currency: "Balboa panameña" },
    { code: "PEN", country: "Perú", currency: "Sol peruano" },
    { code: "PGK", country: "Papúa Nueva Guinea", currency: "Kina" },
    { code: "PHP", country: "Filipinas", currency: "Peso filipino" },
    { code: "PKR", country: "Pakistán", currency: "Rupia pakistaní" },
    { code: "PLN", country: "Polonia", currency: "Zloty polaco" },
    { code: "PYG", country: "Paraguay", currency: "Guaraní paraguayo" },
    { code: "QAR", country: "Catar", currency: "Riyal catarí" },
    { code: "RON", country: "Rumania", currency: "Leu rumano" },
    { code: "RSD", country: "Serbia", currency: "Dinar serbio" },
    { code: "RWF", country: "Ruanda", currency: "Franco ruandés" },
    { code: "SAR", country: "Arabia Saudita", currency: "Riyal saudí" },
    { code: "SBD", country: "Islas Salomón", currency: "Dólar salomonense" },
    { code: "SCR", country: "Seychelles", currency: "Rupia seychellense" },
    { code: "SEK", country: "Suecia", currency: "Corona sueca" },
    { code: "SGD", country: "Singapur", currency: "Dólar de Singapur" },
    { code: "SHP", country: "Santa Elena", currency: "Libra de Santa Elena" },
    { code: "SLL", country: "Sierra Leona", currency: "Leone" },
    { code: "SRD", country: "Surinam", currency: "Dólar surinamés" },
    { code: "SVC", country: "El Salvador", currency: "Colón salvadoreño" },
    { code: "SZL", country: "Esuatini", currency: "Lilangeni" },
    { code: "THB", country: "Tailandia", currency: "Baht tailandés" },
    { code: "TJS", country: "Tayikistán", currency: "Somoni tayiko" },
    { code: "TMT", country: "Turkmenistán", currency: "Manat turcomano" },
    { code: "TND", country: "Túnez", currency: "Dinar tunecino" },
    { code: "TOP", country: "Tonga", currency: "Paʻanga" },
    { code: "TRY", country: "Turquía", currency: "Lira turca" },
    { code: "TTD", country: "Trinidad y Tobago", currency: "Dólar trinitense" },
    { code: "TWD", country: "Taiwán", currency: "Nuevo dólar taiwanés" },
    { code: "TZS", country: "Tanzania", currency: "Chelín tanzano" },
    { code: "UAH", country: "Ucrania", currency: "Grivna ucraniana" },
    { code: "UGX", country: "Uganda", currency: "Chelín ugandés" },
    { code: "UYU", country: "Uruguay", currency: "Peso uruguayo" },
    { code: "UZS", country: "Uzbekistán", currency: "Som uzbeko" },
    { code: "VND", country: "Vietnam", currency: "Dong vietnamita" },
    { code: "VUV", country: "Vanuatu", currency: "Vatu" },
    { code: "WST", country: "Samoa", currency: "Tala" },
    { code: "XCD", country: "Caribe Oriental", currency: "Dólar del Caribe Oriental" },
    { code: "XOF", country: "África Occidental", currency: "Franco CFA" },
    { code: "XPF", country: "Polinesia Francesa", currency: "Franco CFP" },
    { code: "ZAR", country: "Sudáfrica", currency: "Rand sudafricano" },
    { code: "ZMW", country: "Zambia", currency: "Kwacha zambiano" }
].sort((a, b) => {
    return a.currency.localeCompare(b.currency, "es", { sensitivity: "base" });
});;
